import moment from 'moment'

export const GpsStandardTime = moment.utc('06/01/1980', 'DD/MM/YYYY')
export const UnixStandardTime = moment.utc('01/01/1970', 'DD/MM/YYYY')
